import { AppState } from '../initialStateRegistration';

export const getHeaderWithSubMenus = (state: AppState) => state.headerWithSubMenus;
